module.exports = __webpack_public_path__ + "img/Website.c1674bca.svg";